import css from "./BrowserPanel.sass?inline"
import {Lifecycle} from "@opendaw/lib-std"
import {StudioService} from "@/service/StudioService.ts"
import {createElement} from "@opendaw/lib-jsx"
import {SampleBrowser} from "@/ui/browse/SampleBrowser.tsx"
import {Html} from "@opendaw/lib-dom"

const className = Html.adoptStyleSheet(css, "BrowserPanel")

type Construct = {
    lifecycle: Lifecycle
    service: StudioService
}

export const BrowserPanel = ({lifecycle, service}: Construct) => {
    return (
        <div className={className}>
            <SampleBrowser lifecycle={lifecycle}
                           service={service}
                           background
                           fontSize="0.75em"/>
        </div>
    )
}